import { useState, useEffect } from "react";

/**
 * ADE Loading Spinner - Logo that fills with color clockwise
 * Replaces the 3-dot loading indicator
 */
export const AdeLoadingSpinner = ({ size = "md", className = "" }) => {
  const [rotation, setRotation] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 3) % 360);
    }, 16); // ~60fps
    
    return () => clearInterval(interval);
  }, []);
  
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24"
  };
  
  const sizePixels = {
    sm: 32,
    md: 48,
    lg: 64,
    xl: 96
  };
  
  const pixels = sizePixels[size] || 48;
  
  return (
    <div className={`relative ${sizeClasses[size] || sizeClasses.md} ${className}`}>
      {/* Gray base logo */}
      <img
        src="/images/ade-logo-extracted.png"
        alt=""
        className={`${sizeClasses[size] || sizeClasses.md} object-contain absolute top-0 left-0 grayscale opacity-30`}
      />
      
      {/* Colored logo with conic gradient mask - fills clockwise */}
      <div 
        className={`${sizeClasses[size] || sizeClasses.md} absolute top-0 left-0 overflow-hidden`}
        style={{
          maskImage: `conic-gradient(from 0deg, black ${rotation}deg, transparent ${rotation}deg)`,
          WebkitMaskImage: `conic-gradient(from 0deg, black ${rotation}deg, transparent ${rotation}deg)`,
        }}
      >
        <img
          src="/images/ade-logo-extracted.png"
          alt=""
          className={`${sizeClasses[size] || sizeClasses.md} object-contain drop-shadow-lg`}
        />
      </div>
    </div>
  );
};

/**
 * Full page loading screen with ADE spinner
 */
export const AdeLoadingScreen = ({ message = "" }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-white via-orange-50/30 to-pink-50/30">
      <AdeLoadingSpinner size="xl" />
      {message && (
        <p className="mt-4 text-gray-500 text-sm animate-pulse">{message}</p>
      )}
    </div>
  );
};

/**
 * Inline loading indicator
 */
export const AdeLoadingInline = ({ size = "sm" }) => {
  return (
    <div className="flex items-center justify-center py-4">
      <AdeLoadingSpinner size={size} />
    </div>
  );
};

export default AdeLoadingSpinner;
